import { LIVE_CHAT_COMMUNICATION_TYPES, ASYNC_CHAT_COMMUNICATION_TYPES } from 'constants/conversationTypes';

export const isLiveChat = (communicationType) => LIVE_CHAT_COMMUNICATION_TYPES.includes(communicationType);

export const isAsyncChat = (ticket) => ASYNC_CHAT_COMMUNICATION_TYPES.includes(ticket.communicationType);

export const isDelayedAsyncChat = (ticket) => isAsyncChat(ticket) && ticket.chatResponseState === 'DELAYED';

export const isVoiceCallChat = (ticket) => ticket.communicationType === 'VOICE_CALL';
